import * as React from 'react';
import { forwardRef } from 'react';

export interface DMDivProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
  [key: string]: any;
}

export const DMDiv = forwardRef<HTMLElement, DMDivProps>(
  ({ className = '', as: Component = 'div', children, ...props }, ref) => {
    return (
      <Component ref={ref} className={className} {...props}>
        {children}
      </Component>
    );
  }
);
DMDiv.displayName = 'DMDiv';
